import { MasonryPage } from 'components/masonry-page/masonry-page.component';
import { MASONRY } from 'common/constants';

// HP-6 Health Alerts detail (GEIS-304). Rendered OOTB: the intro, the per-member
// accordion, the empty state and the termed-member gate are all decided by the
// server-driven tree, so nothing is conditional here. Web additionally gets the
// tree's `pageHeaderWeb` heroBanner as the on-page title (native takes the same
// string from the root's `setTitle`).
export const HealthAlertsPage = () => (
  <MasonryPage
    screenName="Health Alerts"
    titleMessageId="STR_HEALTH_ALERTS"
    rootNodeId={MASONRY.ROOT_NODE_ID_HEALTH_ALERTS}
  />
);
